module.exports = __webpack_public_path__ + "static/paper-plane.5da0675d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/paper-plane.png
// module id = ./assets/paper-plane.png
// module chunks = 70144966829960